import script from "./UserList.vue?vue&type=script&setup=true&lang=js"
export * from "./UserList.vue?vue&type=script&setup=true&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=2210956a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2210956a"]])

export default __exports__